import { Link } from 'react-router-dom'
import { PLATFORMS, ECOSYSTEM_PILLARS, ECOSYSTEM_FLYWHEEL } from '@/data/siteData'
import EcosystemSection from '@/components/EcosystemSection/EcosystemSection'
import StatsBand from '@/components/StatsBand/StatsBand'
import CtaSection from '@/components/CtaSection/CtaSection'
import styles from './EcosystemPage.module.css'

export default function EcosystemPage() {
  return (
    <>
      {/* ── HERO ── */}
      <section className={styles.hero} aria-label="Ecosystem overview">
        <div className={styles.heroBg} aria-hidden="true" />
        <div className={styles.content}>
          <p className="section-label">The NexusAI Ecosystem</p>
          <h1 className={styles.title}>
            Three platforms.<br />
            <span className="grad">One seamless identity.</span>
          </h1>
          <p className={styles.sub}>
            Single login. One account. Access SkillNexus, InternNexus, and
            PromptNexus — designed to take every Indian student from learning
            to employment in one continuous journey.
          </p>
        </div>
      </section>

      {/* ── PLATFORM CARDS ── */}
      <section className={styles.cards} aria-label="Platform overview">
        <div className={styles.cardsInner}>
          {PLATFORMS.map(p => (
            <Link to={`/${p.id}`} key={p.id} className={styles.platformCard}>
              <div className={styles.cardTop}>
                <div
                  className={styles.cardIcon}
                  style={{ background: p.colorBg, color: p.color }}
                >
                  {p.abbr}
                </div>
                <span
                  className={styles.cardStatus}
                  style={{ background: p.colorBg, color: p.color, border: `1px solid ${p.colorBorder}` }}
                >
                  {p.modalStatus}
                </span>
              </div>
              <h2 className={styles.cardName}>{p.name}</h2>
              <p className={styles.cardTagline}>{p.tagline}</p>
              <p className={styles.cardDesc}>{p.description}</p>
              <div className={styles.cardArrow} style={{ color: p.color }}>
                Explore {p.name} →
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* ── THE FLYWHEEL ── */}
      <section className={styles.flywheel} aria-label="How the ecosystem connects">
        <div className={styles.flywheelInner}>
          <p className="section-label">How It All Connects</p>
          <h2 className="section-title">One journey, four stages</h2>
          <p className="section-desc" style={{ margin: '0 auto 12px' }}>
            NexusAI isn’t three separate apps — it’s a single pipeline. What you
            do on one platform compounds on the next.
          </p>
          <div className={styles.flowGrid}>
            {ECOSYSTEM_FLYWHEEL.map((s, i) => (
              <div key={s.num} className={styles.flowStep}>
                <span className={styles.flowNum} style={{ color: s.color }}>{s.num}</span>
                <span className={styles.flowPlatform} style={{ color: s.color }}>{s.platform}</span>
                <h3 className={styles.flowTitle}>{s.title}</h3>
                <p className={styles.flowDesc}>{s.desc}</p>
                {i < ECOSYSTEM_FLYWHEEL.length - 1 && (
                  <span className={styles.flowArrow} aria-hidden="true">→</span>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── WHAT CONNECTS THEM ── */}
      <section className={styles.connect} aria-label="What connects the platforms">
        <div className={styles.connectInner}>
          <p className="section-label">The Connective Tissue</p>
          <h2 className="section-title">What makes it one ecosystem</h2>
          <div className={styles.connectGrid}>
            {ECOSYSTEM_PILLARS.map(({ icon, title, desc }) => (
              <div key={title} className={styles.connectCard}>
                <div className={styles.connectIcon}>{icon}</div>
                <h3 className={styles.connectTitle}>{title}</h3>
                <p className={styles.connectDesc}>{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── ECOSYSTEM + JOURNEY ── */}
      <EcosystemSection />

      {/* ── STATS ── */}
      <StatsBand />

      {/* ── CTA ── */}
      <CtaSection />
    </>
  )
}
